var _styled;

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

// https://govuk-elements.herokuapp.com/data/
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { FONT_SIZE, LINE_HEIGHT, MEDIA_QUERIES, NTA_LIGHT } from '@govuk-react/constants';
import TableHeader from './atoms/TableHeader';
import TableBody from './atoms/TableBody';
import Caption from './atoms/Caption';
var StyledTable = styled('table')((_styled = {
  border: 0,
  borderCollapse: 'collapse',
  boxSizing: 'border-box',
  borderSpacing: 0,
  fontFamily: NTA_LIGHT,
  fontWeight: 400,
  textTransform: 'none',
  fontSize: FONT_SIZE.SIZE_14,
  lineHeight: LINE_HEIGHT.SIZE_14,
  width: '100%'
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  fontSize: FONT_SIZE.SIZE_16,
  lineHeight: LINE_HEIGHT.SIZE_16
}, _styled));

var Table = function Table(_ref) {
  var caption = _ref.caption,
      body = _ref.body,
      head = _ref.head,
      props = _objectWithoutProperties(_ref, ["caption", "body", "head"]);

  return React.createElement(StyledTable, props, React.createElement(Caption, null, caption), head && React.createElement(TableHeader, null, head), React.createElement(TableBody, null, body));
};

Table.defaultProps = {
  caption: undefined,
  head: undefined
};
Table.propTypes = process.env.NODE_ENV !== "production" ? {
  body: PropTypes.node.isRequired,
  head: PropTypes.node,
  caption: PropTypes.string
} : {};
export default Table;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/table/es/index.js
// module id = 121
// module chunks = 0